import { Component, Injector, OnInit, forwardRef, ChangeDetectionStrategy } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlContainer, FormGroup, FormControl } from '@angular/forms';

import { OptionValue9 } from '@ui/components/form9/common';

import { InputBase } from '../../../base/input-base';

@Component({
    selector: 'aa-input-hidden9',
    templateUrl: './input-hidden9.component.html',
    styleUrls: [
        '../input9.component.scss'
    ],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef((): typeof InputHidden9Component => InputHidden9Component),
            multi: true
        }],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InputHidden9Component extends InputBase<OptionValue9> implements OnInit
{
    private static identifier = 0;
    public formGroup: FormGroup;

    constructor (
        injector: Injector,
        controlContainer: ControlContainer
    )
    {
        super(injector, controlContainer);

        this.fieldId = `idInputHidden9-${InputHidden9Component.identifier++}-id`;
    }

    ngOnInit (): void
    {
        this.formGroup = this.controlContainer.control as FormGroup;
        this.control = new FormControl('');
        this.formGroup.addControl(this.ctrlName, this.control);
    }
}
